import api from "../api";

export async function GetCompanyList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/company-list/`,
  });
}

export async function GetCountryList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/getCountries`,
  });
}

export async function CreateCompanyData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/company/create-company`,
  });
}

export async function GetCompanyData() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/get-company`,
  });
}

export async function UpdateCompanyData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/company/update-company`,
  });
}

export async function GetCompanySingleRow(id) {
  console.log("EmpReferralServices:26", id);
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/get-company-row/${id}`,
  });
}

export async function DeleteRecords(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/delete-record/${id}`,
  });
}

export async function CreateTemplateData(data) {
  console.log(data, "template data");
  return await api({
    method: "post",
    data: JSON.stringify(data),
    url: `${process.env.REACT_APP_API_URL}/admin/company/mail-template`,
    headers: {
      "content-type": "application/json",
    },
  });
}

export async function GetTemplateList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/gettemplates/`,
  });
}

export async function GetTemplateSingleRow(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/company/get-template-row/${id}`,
  });
}
